import { render, staticRenderFns } from "./systemInfo.vue?vue&type=template&id=22db4726&scoped=true&"
import script from "./systemInfo.vue?vue&type=script&lang=js&"
export * from "./systemInfo.vue?vue&type=script&lang=js&"
import style0 from "./systemInfo.vue?vue&type=style&index=0&id=22db4726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db4726",
  null
  
)

component.options.__file = "systemInfo.vue"
export default component.exports